import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["container", "id", "name", "disabled", "visible", "placeholder", "href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createElementBlock("a", {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.AnchorTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.AnchorTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.AnchorTypeConst.CLASS) ?? '']: true, 'customrequired': _ctx.getPropertyBooleanValue(_ctx.AnchorTypeConst.REQUIRED) }),
        name: _ctx.getPropertyValue(_ctx.AnchorTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.AnchorTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.AnchorTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.AnchorTypeConst.PLACEHOLDER),
        href: _ctx.getPropertyValue(_ctx.AnchorTypeConst.HREF),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clicktest && _ctx.clicktest(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.getPropertyValue(_ctx.AnchorTypeConst.TEXT)) + " " + _toDisplayString(_ctx.vmodel), 1 /* TEXT */)
      ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1)), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.AnchorTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}